const lyrics = [
    '何もできなかったもうさんじゅうさん歳',
    'この気持ちもう何十何回',
    '急げ　じゃなくて　It\'s okay',
    '焦るの反対って　慢慢來',
    '萬事難在起頭 いってらっしゃい',
    'once started 以後　就不只一年半載',
    'サンキュー　相棒　怪獣　八号',
    'みんなのおかげで　ありがたい',
    'この一年間　無理せずに　頑張った',
    '日本語 能力　N2も取った',
    '「エグい」って言われた　けど別に',
    'もっどgreeedy　都会のネズミ',
    '眠い　昼寝は出口',
    'ちょっとリセット　メモリー',
    '遠距離　やらかした片思い',
    'タイミングミスって　近い兎も得ずに (wasted)',
    'たまに　誰かに持ち帰られた',
    '悩み　誰かが遊んでくれた',
    '頑張りますって言いたり',
    'ハサミも切れない　これが運命だ',
    '流れていて、いつもの平和',
    'ストーリーが退屈な映画',
    '工作也都沒差 下班也都回家',
    '成長ではなかったまた同じの部屋',
    '貯金は全然してなかった',
    'あまり変わらない残高',
    '個人的に　浪人の景色',
    '頭の真ん中　富と貧のハザマ',
    '一整年太放縱了都沒存錢',
    '成年了還過得像未成年',
    '楽しく飲み過ぎ　落ち着きべき',
    '該省點了 如果不想未來睡公園',
    'お金稼ぐ　僕はバカ',
    '財布の中　は何もなかった',
    '一気に使ったら　公園の入り口',
    'でも続きます　バイトはまだ　',
    'まさか 都是怠惰的抱怨',
    '怕了吧 人生不怕買 太多個保險',
    '稼いで、節約して',
    '先開源節流 才能賺到錢',
    '一ヶ月の大阪旅行',
    '寝るところは中崎町',
    '思い出と　出会った人',
    '残ってるものは　ほんといろいろ',
    'ラッキーカラーたぶん水色',
    'だって今年もずっとスリコ',
    '日本語の続けるのはみんなの',
    'サポートがある　僕の後ろ　',
    'まだ続ける好きな仕事',
    'あとキセキみたいなバイトも',
    '飛行機乗るみたいな気持ちで',
    'ひとりじゃない　この素敵な地元',
    '什麼都沒做到但也做了很多',
    '想要記錄下來但是不知怎說',
    '歌詞の記録は　混ざった味噌汁',
    '把豐盛的回憶直接煮一整鍋'
];

export default lyrics;

